import React, { useState, useEffect, useRef } from 'react'
import AsyncSelect from 'react-select/async';
import MaterialTable, { MTableToolbar } from 'material-table'
import { Link, useLocation, useNavigate } from 'react-router-dom';
import SlidingPane from "react-sliding-pane";
import "react-sliding-pane/dist/react-sliding-pane.css";
import ContentLoader from 'react-content-loader';
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css";
import _ from "lodash";
import axios from 'axios';
import { ToastContainer, toast } from "react-toastify";
import authHeader from "../../services/auth-header";
import { API } from "../../backend";
import Helper from '../../Helper';
import { getTrans as t } from "../../Localization/translations"
import NotesSingle from '../../components/Notes/NotesSingle';
import DeleteInvoiceService from '../../services/billing/deleteInvoiceService';
import CreditMemoList from '../CreditMemo/CreditMemoList';
import { useSubscriptionFeatures } from "../../contexts/SubscriptionContext";



function Billing({ customerPermission, contractid }) {
	const { planFeatures } = useSubscriptionFeatures();
	const BillingtableRef = useRef(null);
	var contractNumber = ""
	var customerName = ""
	const [selectedValue, setSelectedValue] = useState(null);
	const [inputvalue, setValue] = useState("");
	const [selectedValue2, setSelectedValue2] = useState(null);
	const [inputvalue2, setValue2] = useState("");
	const [loading, setLoading] = useState(true)
	const [isSidePanelOpen, setIsSidePanelOpen] = useState(false);
	const [object_name, setObject_name] = useState('Invoice')
	const [selectedRowId, setSelectedRowId] = useState(null);
	const [state1, setState] = useState({
		isPaneOpen: false,
		isPaneOpenLeft: false,
	});
	const [permissionss, setPermission] = useState(localStorage.getItem('permissions'))
	const permissionsArray = permissionss.split(',');
	const location = useLocation()
	const invoicestatus = location?.state

	const [transactionType, setTransactionType] = useState("Invoice");

	useEffect(() => {
		setLoading((false))
	}, []);

	const handelInputChange2 = (value1) => {
		setValue2(value1);
	}

	const handelChange2 = (value1) => {
		setSelectedValue2(value1)
	}

	const loadOptions2 = async (inputValue2) => {
		if (inputValue2 !== "") {
			const response = await axios.get(
				API + `contracts/contractsactive/filter/?id=${inputValue2}`, { headers: authHeader() }
			);
			return response.data.data
		}
	};

	const handleClear = () => {
		setSelectedValue(null)
		setSelectedValue2(null)
		setTransactionType("Invoice")
		BillingtableRef.current.onQueryChange();
	}

	const handelInputChange = (value) => {
		setValue(value);
	}

	const handelChange = (value) => {
		setSelectedValue(value)
	}

	const loadOptions = async (inputValue) => {
		if (inputValue !== "") {
			const responseJSON = await axios.get(
				API + `parties/vendor/?party_type=Customer&&customer_name=${inputValue}`, { headers: authHeader() }
			);
			return responseJSON.data.data
		}
	};

	let navigate = useNavigate();

	// const handleView = (id, status) => {
	// 	if (status === 'Saved' || status === "Completed") {
	// 		navigate("/billing/viewinvoices", { state: id })
	// 	} else {
	// 		if (customerPermission !== 'Customer') {
	// 			navigate("/billing/editinvoices", { state: id })
	// 		}
	// 	}
	// }

	const handleView = (id) => {
		navigate("/billing/viewinvoices", { state: id });
	};

	const handleEdit = (id) => {
		navigate("/billing/editinvoices", { state: id });
	};




	const handlePartyView = (id) => {
		navigate("/party/details", { state: id })
	}

	const handleContractView = (id,) => {
		navigate("/contract/view", { state: id })
	}


	const isNotesDisabled = planFeatures && planFeatures.notes === false;
	const isCreditMemoDisabled = planFeatures && planFeatures.credit_memo === false;


	useEffect(() => {
		if (BillingtableRef.current) {
			BillingtableRef.current.onQueryChange();
		}
	}, []);


	const handelInvoiceDelete = (id, status) => {
		confirmAlert({
			title: "",
			message: "Are you sure you want to delete this invoice?.",
			buttons: [
				{
					label: "Yes",
					onClick: () => {
						DeleteInvoiceService.deleteinvoice(id).then((response) => {
							if (response.data.success) {
								toast.success(`${response.data.response}`, {
									position: "top-right",
									autoClose: 1000,
									hideProgressBar: false,
									pauseOnHover: true,
									draggable: true,
									progress: undefined,
									theme: "light",
								});
								setTimeout(() => {
									BillingtableRef.current?.onQueryChange();
								}, 500);
							} else {
								toast.error(`${response.data.error}`, {
									position: "top-right",
									autoClose: 1000,
									hideProgressBar: false,
									pauseOnHover: true,
									draggable: true,
									progress: undefined,
									theme: "light",
								});
							}
						})

					},
				},
				{
					label: "No",
				},
			],
		});
	};


	return (
		<>
			{
				loading === false ? (
					<div className="page-wrapper">
						<ToastContainer />
						<div className="content container-fluid">
							<div className="row">
								<div className="">
									<div className="ms-auto my-auto mt-lg-0 mt-4">
										<div className="ms-auto my-auto"></div>
									</div>
								</div>
							</div>
							<div className="card-body">
								<div className="success"></div>
								<div className="row">
								</div>
							</div>
							<SlidingPane
								className="some-custom-class"
								overlayClassName="some-custom-overlay-class"
								isOpen={state1.isPaneOpen}
								title="Filter By"
								subtitle=""
								onRequestClose={() => {
									setState({ isPaneOpen: false });
								}}
							>
								<div className="col-xl-12">
									<div className="form-group row">
										<label className="col-lg-12 col-form-label">{t("Transaction Type")}</label>
										<div className="col-lg-12">
											<select
												className="form-control"
												value={transactionType}
												onChange={(e) => setTransactionType(e.target.value)}
											>
												<option value="Invoice">Invoice</option>
												{!isCreditMemoDisabled && (
													<option value="CreditMemo">Credit Memo</option>
												)}
											</select>
										</div>
									</div>
								</div>
								<div className="col-xl-12">
									<div className="form-group row">
										<label className="col-lg-12 col-form-label">{t("Customer Name")}</label>
										<div className="col-lg-12">
											<AsyncSelect
												defaultOptions
												isClearable
												placeholder={t("Search for Customer(%for All)")}
												value={selectedValue}
												getOptionLabel={e => e.customer_name}
												getOptionValue={e => e.customer_name}
												loadOptions={loadOptions}
												onInputChange={handelInputChange}
												onChange={handelChange}
											>
											</AsyncSelect>
										</div>
									</div>
								</div>

								<div className="col-xl-12">
									<div className="form-group row">
										<label className="col-lg-12 col-form-label">{t("Contract Number")}</label>
										<div className="col-lg-12">
											<AsyncSelect
												defaultOptions
												isClearable
												placeholder={t("Search for Contract(%for All)")}
												value={selectedValue2}
												getOptionLabel={e => e.contract_number}
												getOptionValue={e => e.contract_number}
												loadOptions={loadOptions2}
												onInputChange={handelInputChange2}
												onChange={handelChange2}
											>
											</AsyncSelect>
										</div>
									</div>
								</div>

								<div className="col-xl-12">
									<div className="form-group row">
										<div className="col-lg-12 text-left" style={{ marginTop: "30px" }}>
											<button type="button" className="clearReceipt btn bg-gradient-secondary ms-auto mb-0" onClick={handleClear}>{t("RESET")}</button>&nbsp;&nbsp;
											<button
												type="button"
												className="clearReceipt btn btn-primary ms-auto mb-0"
												onClick={() => {
													if (transactionType === "CreditMemo") {
														navigate("/creditmemo");
													} else {
														setState({ isPaneOpen: false });
														Helper.handleSearch(BillingtableRef);
													}
												}}
											>
												{t("Apply")}
											</button>											
											&nbsp;&nbsp;
										</div>
									</div>
								</div>

							</SlidingPane>
							<div className="filter_invoice">
								<div className="mb-0">
									<div className="">
										<div className="p-0">
											{/* <div className="table-responsive"> */}
											{transactionType === "CreditMemo" ? (
												<CreditMemoList customerPermission={customerPermission} />
											) : (
												<MaterialTable
													tableRef={BillingtableRef}
													style={{
														backgroundColor: "var(--bs-table-bg)",
														borderBottomWidth: "1px",
														boxShadow: "inset 0 0 0 9999px var(--bs-table-accent-bg)",
													}}
													title={<h5 className="mb-0">{t("Invoices")}</h5>}
													columns={[
														{
															title: `${t("Invoice Number")}`,
															field: "invoice_number",
															headerStyle: {
																verticalAlign: "inherit",
																fontWeight: "bold",
																textAlign: "left"
															},
															cellStyle: {
																textAlign: "left",
																fontSize: 12,
															},
															render: rowData => <> <div className="d-xl-none tc d-md-none d-lg-none" style={{ width: "10px" }}>{t("Invoice Number")}</div> <div className="hyperlink"
																onClick={() =>
																	// rowData.invoice_status === "unSaved" ?
																	// 	permissionss && permissionsArray.includes('change_invoiceheader') === true && handleView(rowData.id, rowData.invoice_status) :
																	permissionss && permissionsArray.includes('view_invoiceheader') === true && handleView(rowData.id, rowData.invoice_status)}>{(rowData.invoice_number)}</div></>
														},
														{
															title: `${t("Transaction Date")}`,
															field: "creation_date",
															render: rowData => <> <div className="d-xl-none tc d-md-none d-lg-none">{t("Transaction Date")}</div><div> {Helper.DateNormal(rowData.creation_date)}</div></>,
															headerStyle: {
																verticalAlign: "inherit",
																fontWeight: "bold",
																textAlign: "left"
															},
															cellStyle: {
																textAlign: "left",
																fontSize: 12
															}
														},
														{
															title: `${t("Due Date")}`,
															field: "due_date",
															render: rowData => <> <div className="d-xl-none tc d-md-none d-lg-none">{t("Due Date")}</div><div> {rowData.due_date ? Helper.DateNormal(rowData.due_date) : "None"}</div></>,
															// export: false,
															headerStyle: {
																verticalAlign: "inherit",
																fontWeight: "bold",
																textAlign: "left"
															},
															cellStyle: {
																textAlign: "left",
																fontSize: 12
															}
														},
														{
															title: `${t("Invoice Amount")}`,
															field: "total_amount",
															render: rowData => <> <div className={`d-xl-none tc d-md-none d-lg-none`} style={{ textAlign: rowData.isSmallScreen ? 'left' : 'right', fontSize: '12px', fontWeight: rowData.isSmallScreen ? 'bold' : '' }}
															>{t("Invoice Amount")}</div><div className={`d-none d-xl-block d-lg-block text-right`} style={{ textAlign: 'right', fontSize: '12px' }}>{Helper.Amount(rowData.total_amount)}</div></>,
															headerStyle: {
																verticalAlign: "inherit",
																fontWeight: "bold",
																textAlign: "right"
															},
															// cellStyle: {
															// 	textAlign: "right",
															// 	fontSize: 12
															// }
														},
														{
															title: `${t("Remaining Amount")}`,
															field: "balance_amount",
															render: rowData => <> <div className={`d-xl-none tc d-md-none d-lg-none`} style={{ textAlign: rowData.isSmallScreen ? 'left' : 'right', fontSize: '12px', fontWeight: rowData.isSmallScreen ? 'bold' : '' }}
															>{t("Remaining Amount")}</div>
																<div className={`d-none d-xl-block d-lg-block text-right`} style={{ textAlign: 'right', fontSize: '12px' }}>{Helper.Amount(rowData.balance_amount)}</div></>,

															headerStyle: {
																width: 100,
																verticalAlign: "inherit",
																fontWeight: "bold",
																textAlign: "right"
															},
															// cellStyle: {
															// 	textAlign: "right",
															// 	fontSize: 12
															// }
														},
														{
															title: `${t("Days Past Due")}`,
															field: "",
															render: rowData => <> <div className="d-xl-none tc d-md-none d-lg-none">{t("Day Past Due")}</div><div>{rowData.balance_amount === 0 ? '0 days' : Helper.DueDays(rowData.due_date)}</div></>,
															headerStyle: {
																verticalAlign: "inherit",
																fontWeight: "bold",
																textAlign: "left"
															},
															cellStyle: {
																textAlign: "left",
																fontSize: 12
															}
														},
														{
															title: `${t("Contract Number")}`,
															field: "contract_id.contract_number",
															render: rowData => <> <div className="d-xl-none tc d-md-none d-lg-none">{t("Contract No")}</div> <div className="hyperlink" onClick={() =>
																permissionss && permissionsArray.includes('view_contract') === true ? handleContractView(rowData.contract_id.id,) : ""}>{(rowData.contract_id.contract_number)}</div></>,
															headerStyle: {
																verticalAlign: "inherit",
																fontWeight: "bold",
																textAlign: "left"
															},
															cellStyle: {
																textAlign: "left",
																fontSize: 12
															}
														},
														{
															title: `${t("Customer Name")}`,
															field: "customer_name",
															render: rowData => <> <div className="d-xl-none tc d-md-none d-lg-none">{t("Customer Name")}</div><div className={`${customerPermission !== 'Customer' && 'hyperlink'}`} onClick={() =>
																permissionss && permissionsArray.includes('view_party') === true ? customerPermission !== 'Customer' &&
																	handlePartyView(rowData.contract_id.party,) : ""}>{(rowData.customer_name)}</div></>,
															headerStyle: {
																verticalAlign: "inherit",
																fontWeight: "bold",
																textAlign: "left"
															},
															cellStyle: {
																textAlign: "left",
																fontSize: 12
															}
														},
														{
															title: `${t("Notes")}`,
															field: "",
															hidden: customerPermission !== 'Customer' ? false : true,
															render: (rowData) => (
																<>
																	<div className="d-xl-none tc d-md-none d-lg-none">
																		{t("Notes")}
																	</div>
																	<div
																		onClick={() => {
																			if (isNotesDisabled) return;
																			setIsSidePanelOpen(true);
																			setSelectedRowId(rowData.id);
																		}}
																		style={{
																			opacity: isNotesDisabled ? 0.5 : 1,
																			cursor: isNotesDisabled ? 'not-allowed' : 'pointer',
																			filter: isNotesDisabled ? 'grayscale(100%)' : 'none'
																		}}
																	>
																		<span className="cursor-pointer">
																			{rowData.has_notes ?
																				<img
																					src={
																						process.env.PUBLIC_URL +
																						"/static/assets/img/curved-images/icons8-sticky-notes-96.png"
																					}
																					alt="notes"
																					height='30px'
																					width='30px'
																				/> :
																				<><img
																					src={process.env.PUBLIC_URL +
																						"/static/images/iconplus.png"}
																					alt="notes"
																					height='22px'
																					width='22px' /></>
																			}
																			{isNotesDisabled && <span style={{ fontSize: '10px', marginLeft: '2px' }}>🔒</span>}
																		</span>
																	</div>
																	{isSidePanelOpen && selectedRowId === rowData.id && (
																		<NotesSingle
																			setIsSidePanelOpen={setIsSidePanelOpen}
																			isSidePanelOpen={isSidePanelOpen}
																			state={selectedRowId}
																			object_name={object_name}
																		/>
																	)}
																</>
															),
															headerStyle: {
																verticalAlign: "inherit",
																fontWeight: "bold",
																textAlign: "left",
															},
															cellStyle: {
																textAlign: "left",
																fontSize: 12,
															},
														},
														{
															title: `${t("Status")}`,
															field: "invoice_status",
															render: rowData => <> <div className="d-xl-none tc d-md-none d-lg-none">{t("Status")}</div>
																<div className={rowData.invoice_status === 'Completed' ? 'badge bg-gradient-success text-xxs' : 'badge badge-sm bg-gradient-secondary'}>{(rowData.invoice_status)}</div></>,
															headerStyle: {
																verticalAlign: "inherit",
																fontWeight: "bold",
																textAlign: "left"
															},
															cellStyle: {
																textAlign: "left",
																fontSize: 12
															}
														},
													]}
													data={query =>
														new Promise((resolve, reject) => {
															const { orderBy, orderDirection } = query;

															if (selectedValue2 && selectedValue) {
																contractNumber = selectedValue2.contract_number;
																customerName = selectedValue.customer_name;
															}
															else if (selectedValue2) {
																contractNumber = selectedValue2.contract_number;

															}
															else if (selectedValue) {
																customerName = selectedValue.customer_name;

															}
															let url = API + "billing/invoices/?"
															url += `status=${invoicestatus !== null ? contractid !== null ? "" : invoicestatus : ""}`
															url += '&per_page=' + query.pageSize
															url += '&page=' + (query.page + 1)
															url += '&search=' + query.search
															url += `&contractNumber=${contractNumber !== "" ? contractNumber : ""}`
															url += `&customerName=${customerName !== "" ? customerName : ""}`
															url += `&contractid=${contractid !== "" ? contractid : ""}`
															if (orderBy) {
																url += `&orderBy=${orderBy.field}`;
																url += `&orderDirection=${orderDirection}`;
															}
															fetch(url, { headers: authHeader() })
																.then(response => response.json())
																.then(result => {
																	resolve({
																		data: query.orderBy && query.orderDirection
																			? _.orderBy(
																				result.data,
																				[query.orderBy.field],
																				[query.orderDirection]
																			)
																			: result.data,
																		page: result.page - 1,
																		totalCount: result.total,
																	})
																})
														})
													}
													actions={
														permissionss && permissionsArray.includes('delete_invoiceheader')
															? [
																// EDIT (always exists, just invisible when not Draft)
																(rowData) => ({
																	icon: () => (
																		<img
																			src={process.env.PUBLIC_URL + "/static/images/ic-edit.svg"}
																			alt="edit"
																			style={{
																				visibility: rowData.invoice_status === "Draft" ? "visible" : "hidden",
																			}}
																		/>
																	),
																	tooltip: "Edit",
																	onClick: (event, rowData) => {
																		if (rowData.invoice_status === "Draft") {
																			handleEdit(rowData.id);
																		}
																	},
																	disabled: rowData.invoice_status !== "Draft",
																}),

																// DELETE (always visible, just icon swap)
																(rowData) => ({
																	icon: () => (
																		<img
																			src={
																				rowData.invoice_status === "Draft"
																					? process.env.PUBLIC_URL + "/static/images/ic-delete.svg"
																					: process.env.PUBLIC_URL + "/static/images/ic-grey-delete.svg"
																			}
																			alt="delete"
																		/>
																	),
																	tooltip: "Delete",
																	onClick: (event, rowData) => {
																		if (rowData.invoice_status === "Draft") {
																			handelInvoiceDelete(rowData.id, rowData.invoice_status);
																		}
																	},
																	disabled: rowData.invoice_status !== "Draft",
																}),
															]
															: []
													}
													components={{
														Toolbar: props => (
															<div className='MuiToolbar-root MTableToolbar-spacer-21  my-temp-class'>
																<MTableToolbar {...props} />
																<span onClick={() => setState({ isPaneOpen: true })} style={{ color: "#b4b7c5", paddingRight: "1px", cursor: "pointer" }}>
																	<img src={process.env.PUBLIC_URL + '/static/images/ic-filter.svg'} alt="filter" />
																</span>
																{/* {
																permissionss && permissionsArray.includes('add_invoiceheader') === true ?
																	customerPermission !== 'Customer' &&
																	<Link className="navbar-brand m-0" to="/billing/createinvoices" >
																		<button className="add-part btn btn-primary  mb-0" id="add-task" >+&nbsp; {t('New Invoice')}</button>
																	</Link>
																	: null
															} */}
																{
																	permissionss &&
																		permissionsArray.includes("add_invoiceheader") === true &&
																		customerPermission !== "Customer" ? (
																		<div className="dropdown">
																			<button
																				className="btn btn-primary mb-0 dropdown-toggle"
																				data-bs-toggle="dropdown"
																				type="button"
																			>
																				+ {t("New Invoice")}
																			</button>

																			<ul
																				className="dropdown-menu"
																				style={{ padding: "15px" }}
																			>
																				<li>
																					<span
																						className="dropdown-item"
																						onClick={() =>
																							navigate("/billing/createinvoices")
																						}
																						style={{ cursor: "pointer" }}
																					>
																						{t("New Invoice")}
																					</span>
																				</li>

																				<li>
																					<span
																						className="dropdown-item"
																						onClick={() => {
																							if (isCreditMemoDisabled) return;
																							navigate("/creditmemo/add");
																						}}
																						style={{
																							cursor: isCreditMemoDisabled ? "not-allowed" : "pointer",
																							color: isCreditMemoDisabled ? "#aaa" : undefined,
																							pointerEvents: isCreditMemoDisabled ? "none" : "auto",
																						}}
																					>
																						{t("New Credit Memo")}
																					</span>
																				</li>
																			</ul>
																		</div>
																	) : null
																}
															</div>
														)
													}}
													options={{
														headerStyle: {
															backgroundColor: "white",
															color: "#245C7F",
															fontSize: 11,
														},
														rowStyle: (rowData, index) => {
															if (index % 2) {
																return { backgroundColor: "#fff" }
															}
														},
														sorting: true,
														search: true,
														toolbar: true,
														paging: true,
														pageSize: 10,
														emptyRowsWhenPaging: false,
														pageSizeOptions: [10, 20, 25, 50],
														paginationType: "stepped",
														showFirstLastPageButtons: false,
														actionsColumnIndex: -1,
													}}
												/>
											)}
											{/* </div> */}
										</div>
									</div>
								</div>
							</div>
							{/* </div> */}
						</div>
					</div>
				) : (
					<ContentLoader
						viewBox="0 0 1000 550"
						backgroundColor="rgba(0,0,0,0.06)"
						foregroundColor="rgba(0,0,0,0.12)"
					>
						<rect x="51" y="45" rx="3" ry="3" width="906" height="17" />
						<circle cx="879" cy="123" r="11" />
						<circle cx="914" cy="123" r="11" />
						<rect x="104" y="115" rx="3" ry="3" width="141" height="15" />
						<rect x="305" y="114" rx="3" ry="3" width="299" height="15" />
						<rect x="661" y="114" rx="3" ry="3" width="141" height="15" />
						<rect x="55" y="155" rx="3" ry="3" width="897" height="2" />
						<circle cx="880" cy="184" r="11" />
						<circle cx="915" cy="184" r="11" />
						<rect x="105" y="176" rx="3" ry="3" width="141" height="15" />
						<rect x="306" y="175" rx="3" ry="3" width="299" height="15" />
						<rect x="662" y="175" rx="3" ry="3" width="141" height="15" />
						<rect x="56" y="216" rx="3" ry="3" width="897" height="2" />
						<circle cx="881" cy="242" r="11" />
						<circle cx="916" cy="242" r="11" />
						<rect x="106" y="234" rx="3" ry="3" width="141" height="15" />
						<rect x="307" y="233" rx="3" ry="3" width="299" height="15" />
						<rect x="663" y="233" rx="3" ry="3" width="141" height="15" />
						<rect x="57" y="274" rx="3" ry="3" width="897" height="2" />
						<circle cx="882" cy="303" r="11" />
						<circle cx="917" cy="303" r="11" />
						<rect x="107" y="295" rx="3" ry="3" width="141" height="15" />
						<rect x="308" y="294" rx="3" ry="3" width="299" height="15" />
						<rect x="664" y="294" rx="3" ry="3" width="141" height="15" />
						<rect x="58" y="335" rx="3" ry="3" width="897" height="2" />
						<circle cx="881" cy="363" r="11" />
						<circle cx="916" cy="363" r="11" />
						<rect x="106" y="355" rx="3" ry="3" width="141" height="15" />
						<rect x="307" y="354" rx="3" ry="3" width="299" height="15" />
						<rect x="663" y="354" rx="3" ry="3" width="141" height="15" />
						<rect x="57" y="395" rx="3" ry="3" width="897" height="2" />
						<circle cx="882" cy="424" r="11" />
						<circle cx="917" cy="424" r="11" />
						<rect x="107" y="416" rx="3" ry="3" width="141" height="15" />
						<rect x="308" y="415" rx="3" ry="3" width="299" height="15" />
						<rect x="664" y="415" rx="3" ry="3" width="141" height="15" />
						<rect x="55" y="453" rx="3" ry="3" width="897" height="2" />
						<rect x="51" y="49" rx="3" ry="3" width="2" height="465" />
						<rect x="955" y="49" rx="3" ry="3" width="2" height="465" />
						<circle cx="882" cy="484" r="11" />
						<circle cx="917" cy="484" r="11" />
						<rect x="107" y="476" rx="3" ry="3" width="141" height="15" />
						<rect x="308" y="475" rx="3" ry="3" width="299" height="15" />
						<rect x="664" y="475" rx="3" ry="3" width="141" height="15" />
						<rect x="55" y="513" rx="3" ry="3" width="897" height="2" />
						<rect x="52" y="80" rx="3" ry="3" width="906" height="17" />
						<rect x="53" y="57" rx="3" ry="3" width="68" height="33" />
						<rect x="222" y="54" rx="3" ry="3" width="149" height="33" />
						<rect x="544" y="55" rx="3" ry="3" width="137" height="33" />
						<rect x="782" y="56" rx="3" ry="3" width="72" height="33" />
						<rect x="933" y="54" rx="3" ry="3" width="24" height="33" />
					</ContentLoader>
				)}
		</>
	)
}

export default Billing
